import { Stack } from "@braintrust/braintrust-ui-components";
import {
  openIdentityVerificationModal,
  VerifyIdentityModalBottomSection,
  VerifyIdentityModalTopSection,
} from "@js/apps/identity-verification";
import { ModalInstance } from "@js/components/modal";

import styles from "./styles.module.scss";

type VerifyIdentityToAcceptOfferModalProps = {
  onVerificationSuccess: () => void;
  onVerificationFail?: () => void;
};

export const VerifyIdentityToAcceptOfferModal = ({
  onVerificationFail,
  onVerificationSuccess,
}: VerifyIdentityToAcceptOfferModalProps) => {
  const onVerifyIdentityClick = () => {
    ModalInstance.close();
    openIdentityVerificationModal({
      isAcceptOfferFlow: true,
      onVerificationFail,
      onVerificationSuccess,
    });
  };

  const handleSkip = () => {
    ModalInstance.close();
  };

  return (
    <Stack>
      <VerifyIdentityModalTopSection
        onSkip={handleSkip}
        title="Verify your identity to officially accept your offer."
        subtitle="REQUIRED TO ACCEPT"
      />
      <VerifyIdentityModalBottomSection
        onVerifyIdentityClick={onVerifyIdentityClick}
      />
    </Stack>
  );
};

export const openVerifyIdentityToAcceptOfferModal = (
  arg: VerifyIdentityToAcceptOfferModalProps,
) => {
  ModalInstance.open({
    children: <VerifyIdentityToAcceptOfferModal {...arg} />,
    padding: false,
    className: styles.modal,
    closeButton: false,
  });
};
